"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    color: palette.tFilled,
    fontSize: palette.tsNormal,
    lineHeight: 1.5,
    fontFamily: palette.fontFamily,
    paddingRight: '0',
    paddingBottom: palette.gutter + 'px',
    paddingTop: palette.gutter + 'px',
    paddingLeft: '0',
    textAlign: 'left',
    display: 'inline-block',
    verticalAlign: 'baseline',
    width: 'auto',
    minWidth: "".concat(palette.gutter * 20, "px"),
    labelColor: palette.tLabel,
    labelFontSize: palette.tsXSmall,
    labelLineHeight: palette.tlXSmall,
    labelPaddingRight: '0',
    labelPaddingLeft: '0',
    labelOverflow: 'visible',
    idleColor: palette.tFilled,
    idlePlaceholder: palette.tHint,
    idleLabelColor: palette.tLabel,
    idleBorderColor: palette.elDivider,
    idleBorderStyle: 'none none solid',
    idleBorderWidth: '1px',
    idleBorderTransform: 'scale(0)',
    idleBorderRadius: '0',
    idleBackground: 'transparent',
    focusColor: palette.tActive,
    focusPlaceholder: palette.tPlaceholder,
    focusLabelColor: palette.tAccent,
    focusBorderColor: palette.elAccent,
    focusBorderStyle: 'none none solid',
    focusBorderWidth: '2px',
    focusBorderTransform: 'scaleX(1)',
    focusBorderRadius: '0',
    focusBackground: 'transparent',
    hoverColor: palette.tFilled,
    hoverPlaceholder: palette.tHint,
    hoverLabelColor: palette.tLabel,
    hoverBorderColor: palette.elSecondary,
    hoverBorderStyle: 'none none solid',
    hoverBorderWidth: '2px',
    hoverBorderTransform: 'scaleX(1)',
    hoverBorderRadius: '0',
    hoverBackground: 'transparent',
    disabledColor: palette.tDisabled,
    disabledLabelColor: palette.tLabel,
    disabledPlaceholder: palette.tPlaceholder,
    disabledBorderTransform: 'scaleX(1)',
    disabledBorderStyle: 'none none dotted',
    disabledBorderWidth: '2px',
    disabledBorderColor: palette.elDivider,
    disabledBorderRadius: '0',
    disabledBackground: 'transparent',
    errorColor: palette.tFilled,
    errorLabelColor: palette.tError,
    errorPlaceholder: palette.tHint,
    errorBorderColor: palette.elError,
    errorBorderStyle: 'none none solid',
    errorBorderWidth: '2px',
    errorBorderTransform: 'scaleX(1)',
    errorBorderRadius: '0',
    errorBackground: 'transparent'
  };
}